import * as PIXI from "pixi.js";
import scaffoldImage from "../assets/scaffold1.png";
import { charaSize } from "../constants";
import { CollisionManager, createRect } from "../managers/collisionManager";
import { LoadManager } from "../managers/loadManager";

export function loadScaffold(loadManager: LoadManager) {
  return {
    scaffold: loadManager.loadTexture(scaffoldImage),
  } as const;
}

export type SetupScaffoldProps = Readonly<{
  scaffoldAssets: ReturnType<typeof loadScaffold>;
  parent: PIXI.Container;
  ticker: PIXI.Ticker;
  collisionManager: CollisionManager;
  x: number;
  y: number;
  width: number;
  height?: number;
}>;

export function setupScaffold({
  scaffoldAssets,
  parent,
  ticker,
  collisionManager,
  x,
  y,
  width,
  height = charaSize,
}: SetupScaffoldProps) {
  const scaffold = new PIXI.Sprite(scaffoldAssets.scaffold.get());
  scaffold.position.set(x, y);
  scaffold.width = width;
  scaffold.height = height;
  const collisionRect = createRect("scaffold", x, y, width, height);

  parent.addChild(scaffold);
  collisionManager.add(collisionRect);
  const dispose = () => {
    parent.removeChild(scaffold);
    collisionManager.remove(collisionRect);
  };

  return dispose;
}
